export default __webpack_public_path__ + "static/media/CarImages.PRunnerGallery4.3a35f088.jpg";